export default __webpack_public_path__ + "static/media/Database_duotone.91eb3a3c.svg";